<div>
    <div class="col-sm-12 pb-2 border-bottom table-filter">
        <form [formGroup]="form" (submit)="search(form)" class="d-flex flex-row align-items-center flex-wrap"> 
            <fieldset class="d-contents">
                <legend class="visually-hidden">Filter and search submissions</legend>
                <edl-floating-label-container *ngIf="canViewRequestType" label="Request Type" for="submissionsRequestTypeSelector"   class="w-auto mt-2 mb-2 me-sm-2 mb-sm-0">
                    <select id="submissionsRequestTypeSelector"
                        (mousedown)="onSelectMouseDown()"
                        (keydown)="handleStatusKeydown($event)"
                        (change)="onDropdownChange($event)"
                        title="Request Type"
                        role="listbox"
                        name="Request Type"
                        class="request-type-selector form-select"
                        formControlName="requestType">
                        <option [value]="RequestTypeFilter.MyRequests" selected="true">My Requests</option>
                        <option [value]="RequestTypeFilter.ManagedRequests">Managed Requests</option>
                    </select>
                </edl-floating-label-container>

            <edl-floating-label-container label="Status Filter" for="submissionsStatusSelector"   class="w-auto mt-2 mb-2 me-sm-2 mb-sm-0">
                <select id="submissionsStatusSelector"
                    (mousedown)="onSelectMouseDown()"
                    (keydown)="handleStatusKeydown($event)"
                    (change)="onDropdownChange($event)"
                    title="Status Filter"
                    name="Status Filter"
                    class="status-selector form-select"
                    formControlName="Status">
                    <option *ngFor="let status of filterStatuses" [value]="status.value" [disabled]="status.disabled">{{status.label}}</option>
                </select>
            </edl-floating-label-container>

            <edl-floating-label-container label="Search" for="submissionsSearchInput" class="w-auto mt-2">
                <div class="input-group">
                    <input id="submissionsSearchInput" type="text" class="form-control search-by-input" formControlName="searchBy" (keydown)="handleSearchKeydown($event)"/>
                    <button title="Search" type="submit" class="input-group-text btn btn-info" aria-label="Search"><i class="fas fa-search" aria-hidden="true"></i></button>
                </div>
            </edl-floating-label-container>
            <div class="d-flex justify-content-end align-items-right">
                <edl-navigation-back-button></edl-navigation-back-button>
            </div>
        </fieldset>
        </form>
    </div>
    <div class="submissions-header mb-3 mt-3">
        <h5 class="mb-0" aria-live="polite" aria-atomic="true">
            {{ selectedRequest.Title }}
        </h5>
    </div>
    <div>
        <div *ngIf="isLoading" class="text-center py-4" aria-busy="true" aria-live="polite">
            <p class="mt-2 text-muted">Loading submissions...</p>
        </div>
        <div *ngIf="!isLoading && pagedResponse?.Results && pagedResponse.Results.length > 0">
            <edl-submissions-list
                [requestItem]="selectedRequest"
                [userRequests]="pagedResponse?.Results || []"
                [isLoading]="isLoading"
                [isMyItems]="isMyItems"
                [activeActionColumns]="activeActionColumns">
            </edl-submissions-list>
        </div>
    </div>

    <div *ngIf="!isLoading && (!pagedResponse?.Results || pagedResponse?.Results.length === 0)" 
         class="text-center py-4">
        <p class="text-muted">No submissions found for this request.</p>
    </div>

    <div *ngIf="!isLoading && pagedResponse" class="content">
        <div class="row">
            <div class="col-sm-12 text-end">
                <comply-pagination
                    [pagedResponse]="pagedResponse"
                    [pageSizes]="[20]">
                </comply-pagination>
            </div>
        </div>
    </div>
</div>